import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = (suffix) => {
  const rand = (Math.floor(Math.random() * 90000000) + 10000).toString();
  return 'aiform' + rand + '_' + suffix;
};

const defaultTemplateData = () => ({
  prompt: '',
  formIdKey: keyAuto('formId'),
  formSessionIdKey: keyAuto('formSessionId'),
  formSessionURLKey: keyAuto('formSessionURL'),
  dataKey: keyAuto('data'),
  answersKey: keyAuto('answers'),
  questionAnswersKey: keyAuto('questionAnswers'),
  questionAnswersHTMLKey: keyAuto('questionAnswersHTML'),
});

const { getStore, defaultStore } = createComponentStore({
  type: 'ai_generated_form',
  endpoint: 'ai-generated-form',
  registryKey: 'ai-generated-form',
  initData: defaultTemplateData,
  onLoadData: (rawData) => ({ ...defaultTemplateData(), ...rawData }),
});

export const getAIGeneratedFormStore = getStore;
export default defaultStore;
